import { UseFormSetValue } from "react-hook-form";
import Select, {
} from "../../UI/Select";
import { SelectClasses } from "../../UI/Select/types";
import { useState } from "react";
import { displayNotify } from "../../../services/Notifications/NotificationServices";

interface Props {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  setValue?: UseFormSetValue<any>;
  formName: string;
  classes?: Partial<SelectClasses>;
  disabled?: boolean;
  disabledMessage?: { title: string; description: string };
}

export default function LabeledSelect({
  label,
  value,
  options,
  setValue,
  formName,
  classes,
  disabled = false,
  disabledMessage
}: Props) {
  const isActive = !!value

  return (
    <div
      className={`labeled-select__wrapper ${isActive ? 'active' : ''}`}
      onClick={() => {
        if (disabled && disabledMessage) {
          displayNotify({
            status: 'info',
            title: `${disabledMessage?.title}`,
            description: `${disabledMessage?.description}`
          })
        } else return
      }}
    >
      <Select
        options={options?.map((option) => option.label)}
        value={value}
        isChangeable
        classes={classes}
        setValue={setValue}
        formName={formName}
        disabled={disabled}
      />
      <label
        className="labeled-select__label"
        style={disabled ? { opacity: 0.3, pointerEvents: "none" } : undefined}
      >
        {label}
      </label>
    </div>
  );
}
